
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"billing"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"login"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"provider"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VCSProviderChoices"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"owner"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"login"},"value":{"kind":"Variable","name":{"kind":"Name","value":"login"}}},{"kind":"Argument","name":{"kind":"Name","value":"provider"},"value":{"kind":"Variable","name":{"kind":"Name","value":"provider"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"billingVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"vcsInstallationId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasPremiumPlan"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"billingInfo"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"billingEmail"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"billingAddress"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"planSlug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"upgradePlans"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"downgradePlans"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seatsTotal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"seatsUsed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastBillAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"upcomingBillAmount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastPaymentDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"upcomingPaymentDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastInvoiceUrl"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cancelAtPeriodEnd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"upcomingCancellationDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"outstandingCredits"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"billingBackend"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"synced"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"pendingUpdate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"clientSecret"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"couponApplied"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"activeCard"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"brand"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"endingIn"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expYear"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"expMonth"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"invoices"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invoiceId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"url"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":874}};
    doc.loc.source = {"body":"query billing($login: String!, $provider: VCSProviderChoices!) {\n  owner(login: $login, provider: $provider) {\n    id\n    login\n    billingVersion\n    vcsInstallationId\n    hasPremiumPlan\n    login\n    billingInfo {\n      billingEmail\n      billingAddress\n      planSlug\n      status\n      upgradePlans\n      downgradePlans\n      seatsTotal\n      seatsUsed\n      lastBillAmount\n      upcomingBillAmount\n      lastPaymentDate\n      upcomingPaymentDate\n      lastInvoiceUrl\n      cancelAtPeriodEnd\n      upcomingCancellationDate\n      outstandingCredits\n      billingBackend\n      synced\n      pendingUpdate\n      clientSecret\n      couponApplied {\n        code\n        description\n      }\n      activeCard {\n        brand\n        endingIn\n        expYear\n        expMonth\n      }\n      invoices {\n        invoiceId\n        date\n        amount\n        url\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["billing"] = oneQuery(doc, "billing");
        
